<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in"
    >
      <!-- <Overlay v-if="tabletPortrait" /> -->
      <MainView />
    </transition>
  </div>
</template>

<script>
import device from 'current-device';
// import Overlay from '@/components/overlay/Overlay.vue';
import MainView from './views/MainView.vue';

export default {
  name: 'App',
  components: {
    MainView,
    // Overlay,
  },
  data() {
    return {
      tabletPortrait: false,
    };
  },
  mounted() {
    if (device.tablet()) {
      this.tabletPortrait = device.orientation !== 'landscape';
      device.onChangeOrientation((newOrientation) => {
        this.handleTabletOrientation(newOrientation);
      });
    }

    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => {
        this.$store.commit('setLoaded', true);
      });
    } else {
      this.$store.commit('setLoaded', true);
    }
  },
  methods: {
    handleTabletOrientation(val) {
      if (val === 'landscape') {
        this.tabletPortrait = false;
      } else {
        this.tabletPortrait = true;
      }
    },
  },
};
</script>

<style>

</style>
